import React, { useState, createContext, useEffect, useContext } from 'react'
import MuiThemeProvider from '@material-ui/styles/ThemeProvider'
import { Theme } from '@material-ui/core/styles'
import loadTheme from './loadTheme'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeOptions } from '@material-ui/core'
import { getValue } from 'firebase-utils'
import { mainTheme } from 'themes'
const _ = require('lodash'); // eslint-disable-line

/**
 *
 */
export const ThemeContext = createContext(undefined)

/**
 *
 */

interface ThemeOverride extends Theme {
    isPdcTheme: boolean
}
/**
 *
 */
export interface ThemeProviderProps {
    /**
     * theme being passed down for app being used, should not need to use
     */
    theme?: ThemeOverride
    /**
     * dom children in jsx. do not need to use. wrap your components
     */
    children: React.ReactNode

    /**
     * Allows you to override any or all theme options specifically for this theme provider,
     * this options are merged in before any overrides due to remote config.
     */
    themeOverrides?: ThemeOptions
}

/**
 * Establishes a theme context used by various components throughout part (or all) of an app.
 * This merges in any theme overrides from remote config or props.themeOverrides.
 * The theme context influences the styles applied to components such as typography settings, palettes, etc.
 */
export const ThemeProvider = (props: ThemeProviderProps): React.ReactElement => {
    // The following 3 objects will be merged to form the effective theme object:
    const [defaultTheme, setDefaultTheme] = useState<Theme>(mainTheme)
    const [remoteConfigOverrides, setRemoteConfigOverrides] = useState('{}')
    const themeOverrides = props.themeOverrides || {}

    const loadDefaultTheme = async () => {
        if (props.theme?.isPdcTheme) {
            setDefaultTheme(props.theme)
        } else {
            const theme = await loadTheme()
            setDefaultTheme(theme)
        }
    }

    useEffect(() => {
        loadDefaultTheme()
        getValue('branded_theme_override', setRemoteConfigOverrides)
    }, [])

    const getEffectiveTheme = () => {
        // Merge all theme options (in a sensible order) to compute the effective theme
        let mergedThemeOptions = JSON.parse(JSON.stringify(defaultTheme))
        const valuesToMerge = [JSON.parse(remoteConfigOverrides), themeOverrides]
        valuesToMerge.forEach(options => {
            mergedThemeOptions = _.merge(mergedThemeOptions, options)
        })

        return createMuiTheme(mergedThemeOptions)
    }

    const theme = getEffectiveTheme()

    return (
        <ThemeContext.Provider value={theme}>
            <MuiThemeProvider theme={theme}>
                {props.children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    )
}

/**
 *
 */
export const useThemeContext = () => {
    const themeContext = useContext(ThemeContext)
    if (themeContext === undefined) {
        throw new Error('useThemeContext must be used inside ThemeProvider tags')
    }

    return { ...themeContext }
}
